import React from 'react'
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {closeDialog} from '../../../slices/dialog';
import {selectSelectedRm} from '../../../slices/selected';
import {addRmGroup} from '../../../api/company/rm';

export const AddRmGroup = () => {
    const {register, handleSubmit, errors} = useForm({
        defaultValues: {
            name: "",
        }
    });
    const dispatch = useDispatch();
    const rm = useSelector(selectSelectedRm);
    const {t} = useTranslation();

    const onSave = form => {
        addRmGroup(rm.id, form.name).then(() => dispatch(closeDialog()));
    }

    return (
        <div className="addRmGroup">
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("company_rm_analytics_addGroup_name_label")}</div>
                    <input type="text" name="name" ref={register({required: true})}/>
                    {errors.name && <p className="error">{t("company_rm_analytics_addGroup_name_error")}</p>}
                </div>
                <input type="submit" value={t("company_rm_analytics_addGroup_submit")}/>
            </form>
        </div>
    )
}